<adapt-confirmation-dialog (closed)="onDialogClosed($event)"
                           (initialised)="onInitialised($event)">
    @if (hasImpact) {
        <div>
            The impact of removing
            <adapt-display-label [label]="this.label"
                                 [adaptLinkDisabled]="true"></adapt-display-label>
            will result in:
            <ul class="mt-2">
                <li>
                    <adapt-display-label [label]="this.label"
                                         [adaptLinkDisabled]="true"></adapt-display-label>
                    will be removed from the following:
                    <ul>
                        @if (sourceItemCount > 0) {
                            <li>{{ sourceItemCount }} item{{ sourceItemCount === 1 ? "" : "s" }}</li>
                        }
                        @if (sourceTeamCount > 0) {
                            <li>{{ sourceTeamCount }} team{{ sourceTeamCount === 1 ? "" : "s" }}</li>
                        }
                        @if (sourceObjectiveCount > 0) {
                            <li>{{ sourceObjectiveCount }} objective{{ sourceObjectiveCount === 1 ? "" : "s" }}</li>
                        }
                        @if (sourceSystemCount > 0) {
                            <li>{{ sourceSystemCount }} system{{ sourceSystemCount === 1 ? "" : "s" }}</li>
                        }
                        @if (sourceProcessStepCount > 0) {
                            <li>{{ sourceProcessStepCount }} process step{{ sourceProcessStepCount === 1 ? "" : "s" }}</li>
                        }
                        @if (sourceRoleCount > 0) {
                            <li>{{ sourceRoleCount }} role{{ sourceRoleCount === 1 ? "" : "s" }}</li>
                        }
                    </ul>
                </li>
            </ul>
        </div>
    }
</adapt-confirmation-dialog>
